
(() => {
  const menu = document.querySelector('header .menu');
  const nav = document.querySelector('header nav');
  const dropdown = document.querySelector('.nav-dropdown');
  const dropButton = document.querySelector('.nav-dropbtn');

  if (menu && nav) {
    menu.addEventListener('click', (event) => {
      event.preventDefault();
      const open = nav.classList.toggle('open');
      menu.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  if (dropButton && dropdown) {
    dropButton.addEventListener('click', (event) => {
      event.preventDefault();
      dropdown.classList.toggle('open');
    });
  }

  document.addEventListener('click', (event) => {
    if (nav && menu && !nav.contains(event.target) && !menu.contains(event.target)) {
      nav.classList.remove('open');
      menu.setAttribute('aria-expanded', 'false');
    }
    if (dropdown && !dropdown.contains(event.target)) {
      dropdown.classList.remove('open');
    }
  });

  // Shopify predictive search for the Version 27 search box.
  const searchForm = document.querySelector('.center-search-wrap');
  const searchInput = document.querySelector('.header-search-input');
  const results = document.querySelector('.autocomplete-results');
  let requestId = 0;

  if (searchForm && searchInput && results) {
    const closeResults = () => {
      results.classList.remove('open');
      results.innerHTML = '';
    };

    searchInput.addEventListener('input', async () => {
      const q = searchInput.value.trim();
      const thisRequest = ++requestId;

      if (q.length < 2) {
        closeResults();
        return;
      }

      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last`;
        const response = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Search request failed');
        const data = await response.json();
        if (thisRequest !== requestId) return;

        const predictive = data.resources?.results || {};
        const items = [
          ...(predictive.products || []).map(item => ({title:item.title, url:item.url, type:'Product'})),
          ...(predictive.collections || []).map(item => ({title:item.title, url:item.url, type:'Collection'})),
          ...(predictive.pages || []).map(item => ({title:item.title, url:item.url, type:'Page'}))
        ].slice(0, 6);

        results.innerHTML = items.map(item =>
          `<a href="${item.url}"><span>${item.title}</span><small>${item.type}</small></a>`
        ).join('') + `<a class="search-view-all" href="/search?q=${encodeURIComponent(q)}">View all results →</a>`;
        results.classList.add('open');
      } catch (error) {
        closeResults();
      }
    });

    document.addEventListener('click', event => {
      if (!searchForm.contains(event.target)) closeResults();
    });
  }

  // Product image thumbnails.
  const mainProductImage = document.querySelector('[data-main-product-image]');
  document.querySelectorAll('[data-product-thumb]').forEach(button => {
    button.addEventListener('click', () => {
      if (!mainProductImage) return;
      const src = button.dataset.productThumb;
      const alt = button.dataset.productAlt || '';
      if (src) {
        mainProductImage.src = src;
        mainProductImage.alt = alt;
      }
    });
  });


  // Inventory-aware product and cart controls.
  const variantSelector = document.querySelector('[data-variant-selector]');
  const singleVariant = document.querySelector('[data-single-variant]');
  const quantityInput = document.querySelector('[data-product-quantity]');
  const addToCartButton = document.querySelector('[data-add-to-cart]');
  const stockNote = document.querySelector('[data-stock-note]');
  const productForm = document.querySelector('[data-stock-product-form]');
  const productQtyDecrease = document.querySelector('[data-product-quantity-decrease]');
  const productQtyIncrease = document.querySelector('[data-product-quantity-increase]');
  let cartSnapshot = null;

  async function getCartSnapshot(force = false) {
    if (cartSnapshot && !force) return cartSnapshot;
    try {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!response.ok) throw new Error('Could not read cart');
      cartSnapshot = await response.json();
      return cartSnapshot;
    } catch (error) {
      return { items: [] };
    }
  }

  function qtyAlreadyInCart(cart, variantId) {
    const target = String(variantId || '');
    return (cart.items || []).reduce((sum, item) => {
      return sum + (String(item.variant_id) === target ? Number(item.quantity || 0) : 0);
    }, 0);
  }

  function selectedVariantSource() {
    if (variantSelector) {
      return variantSelector.options[variantSelector.selectedIndex];
    }
    return singleVariant;
  }

  function updateProductQuantityButtons() {
    if (!quantityInput) return;

    let value = Number.parseInt(quantityInput.value || '1', 10);
    if (!Number.isFinite(value) || value < 1) value = 1;

    const max = Number.parseInt(quantityInput.max || '', 10);
    const hasMax = Number.isFinite(max);

    if (hasMax && max > 0 && value > max) value = max;
    quantityInput.value = String(value);

    const unavailable = quantityInput.disabled || (hasMax && max <= 0);
    if (productQtyDecrease) productQtyDecrease.disabled = unavailable || value <= 1;
    if (productQtyIncrease) productQtyIncrease.disabled = unavailable || (hasMax && value >= max);
  }

  async function applyVariantStock(source, forceCartRefresh = false) {
    if (!source || !quantityInput || !addToCartButton) return;

    const variantId = source.dataset.variantId || source.value || '';
    const available = String(source.dataset.available) === 'true';
    const inventory = Number.parseInt(source.dataset.inventory || '0', 10);
    const inventoryManagement = source.dataset.inventoryManagement || '';
    const inventoryPolicy = source.dataset.inventoryPolicy || '';
    const stockIsLimited = inventoryManagement !== '' && inventoryPolicy !== 'continue';

    let maxAddable = null;
    let alreadyInCart = 0;

    if (stockIsLimited) {
      const cart = await getCartSnapshot(forceCartRefresh);
      alreadyInCart = qtyAlreadyInCart(cart, variantId);
      maxAddable = Math.max(inventory - alreadyInCart, 0);

      quantityInput.max = String(maxAddable);

      let currentQty = Number.parseInt(quantityInput.value || '1', 10);
      if (!Number.isFinite(currentQty) || currentQty < 1) currentQty = 1;

      if (maxAddable > 0 && currentQty > maxAddable) currentQty = maxAddable;
      quantityInput.value = String(currentQty);

      if (stockNote) {
        if (maxAddable <= 0) {
          stockNote.textContent = alreadyInCart > 0
            ? `All ${inventory} available already in your cart`
            : 'Sold out';
        } else if (alreadyInCart > 0) {
          stockNote.textContent = `${maxAddable} more available · ${alreadyInCart} already in cart`;
        } else {
          stockNote.textContent = `${inventory} available`;
        }
      }
    } else {
      quantityInput.removeAttribute('max');
      if (stockNote) stockNote.textContent = '';
    }

    const soldOut = !available || (stockIsLimited && maxAddable <= 0);
    quantityInput.disabled = soldOut;
    addToCartButton.disabled = soldOut;
    addToCartButton.textContent = soldOut
      ? (alreadyInCart > 0 ? 'Maximum in Cart' : 'Sold Out')
      : 'Add to Cart';

    updateProductQuantityButtons();
  }

  async function refreshSelectedVariant(force = false) {
    await applyVariantStock(selectedVariantSource(), force);
  }

  if (variantSelector) {
    variantSelector.addEventListener('change', () => {
      quantityInput.value = '1';
      refreshSelectedVariant(false);
    });
  }

  if (quantityInput && productQtyDecrease) {
    productQtyDecrease.addEventListener('click', () => {
      let value = Number.parseInt(quantityInput.value || '1', 10);
      if (!Number.isFinite(value) || value < 1) value = 1;
      if (value > 1) quantityInput.value = String(value - 1);
      updateProductQuantityButtons();
    });
  }

  if (quantityInput && productQtyIncrease) {
    productQtyIncrease.addEventListener('click', () => {
      let value = Number.parseInt(quantityInput.value || '1', 10);
      if (!Number.isFinite(value) || value < 1) value = 1;

      const max = Number.parseInt(quantityInput.max || '', 10);
      if (!Number.isFinite(max) || value < max) {
        quantityInput.value = String(value + 1);
      }
      updateProductQuantityButtons();
    });
  }

  if (productForm) {
    productForm.addEventListener('submit', async (event) => {
      event.preventDefault();

      const source = selectedVariantSource();
      if (!source) return;

      const variantId = source.dataset.variantId || source.value || '';
      const inventory = Number.parseInt(source.dataset.inventory || '0', 10);
      const inventoryManagement = source.dataset.inventoryManagement || '';
      const inventoryPolicy = source.dataset.inventoryPolicy || '';
      const stockIsLimited = inventoryManagement !== '' && inventoryPolicy !== 'continue';

      if (stockIsLimited) {
        const cart = await getCartSnapshot(true);
        const alreadyInCart = qtyAlreadyInCart(cart, variantId);
        const remaining = Math.max(inventory - alreadyInCart, 0);
        let requested = Number.parseInt(quantityInput.value || '1', 10);
        if (!Number.isFinite(requested) || requested < 1) requested = 1;

        if (remaining <= 0) {
          await refreshSelectedVariant(true);
          return;
        }

        if (requested > remaining) {
          quantityInput.value = String(remaining);
          requested = remaining;
        }
      }

      addToCartButton.disabled = true;
      addToCartButton.textContent = 'Adding…';

      try {
        const formData = new FormData(productForm);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || 'Could not add item to cart.');
        }

        cartSnapshot = null;
        await refreshSelectedVariant(true);

        // Send the customer to the real Shopify cart after a successful add.
        window.location.href = '/cart';
      } catch (error) {
        addToCartButton.disabled = false;
        addToCartButton.textContent = 'Add to Cart';
        if (stockNote) stockNote.textContent = error.message || 'Could not add this quantity.';
      }
    });
  }

  if (quantityInput && addToCartButton) {
    refreshSelectedVariant(true);
  }

  // Inventory-aware cart controls with immediate Shopify updates.
  const cartForm = document.querySelector('[data-stock-cart-form]');
  const cartQtyInputs = Array.from(document.querySelectorAll('.cart-stock-quantity'));

  function updateCartQuantityButtons(input) {
    const stepper = input.closest('.cart-quantity-stepper');
    if (!stepper) return;

    const decrease = stepper.querySelector('[data-cart-quantity-decrease]');
    const increase = stepper.querySelector('[data-cart-quantity-increase]');
    const value = Number.parseInt(input.value || '0', 10);
    const max = Number.parseInt(input.max || '', 10);
    const hasMax = Number.isFinite(max);

    if (decrease) decrease.disabled = value <= 0;
    if (increase) increase.disabled = hasMax && value >= max;
  }

  function clampCartInput(input) {
    const inventory = Number.parseInt(input.dataset.inventory || '0', 10);
    const inventoryManagement = input.dataset.inventoryManagement || '';
    const inventoryPolicy = input.dataset.inventoryPolicy || '';
    const stockIsLimited = inventoryManagement !== '' && inventoryPolicy !== 'continue';

    let value = Number.parseInt(input.value || '0', 10);
    if (!Number.isFinite(value) || value < 0) value = 0;

    if (stockIsLimited) {
      const max = Math.max(inventory, 0);
      input.max = String(max);
      if (max <= 0) value = 0;
      else if (value > max) value = max;
    } else {
      input.removeAttribute('max');
    }

    input.value = String(value);
    updateCartQuantityButtons(input);
    return value;
  }

  function formatCartMoney(cents) {
    const format = cartForm?.dataset.moneyFormat || '${{ amount }}';
    const amount = Number(cents || 0) / 100;
    const replacements = {
      amount: amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      amount_no_decimals: Math.round(amount).toLocaleString(),
      amount_with_comma_separator: amount.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      amount_no_decimals_with_comma_separator: Math.round(amount).toLocaleString('de-DE')
    };
    return format.replace(/\{\{\s*(amount(?:_no_decimals)?(?:_with_comma_separator)?)\s*\}\}/, (_, token) => replacements[token] ?? replacements.amount);
  }

  async function changeCartLine(input, requestedQty) {
    if (!cartForm) return;
    const key = input.dataset.cartKey;
    if (!key) return;

    input.value = String(Math.max(0, requestedQty));
    const quantity = clampCartInput(input);
    const row = input.closest('[data-cart-row]');
    if (row) row.classList.add('is-updating');

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.description || 'Could not update cart.');
      }

      const updatedCart = await response.json();
      cartSnapshot = updatedCart;

      const count = document.querySelector('.cart-count');
      if (count) count.textContent = String(updatedCart.item_count || 0);

      if (quantity === 0) {
        row?.remove();
        if (!updatedCart.item_count) {
          window.location.reload();
          return;
        }
      } else {
        const updatedItem = (updatedCart.items || []).find(item => String(item.key) === String(key));
        const linePrice = row?.querySelector('[data-cart-line-price]');
        if (updatedItem && linePrice) linePrice.textContent = formatCartMoney(updatedItem.final_line_price);
      }

      const total = document.querySelector('[data-cart-total]');
      if (total) total.textContent = `Total: ${formatCartMoney(updatedCart.total_price)}`;

      if (row) row.classList.remove('is-updating');
      updateCartQuantityButtons(input);
    } catch (error) {
      if (row) row.classList.remove('is-updating');
      window.location.reload();
    }
  }

  cartQtyInputs.forEach(input => {
    const stepper = input.closest('.cart-quantity-stepper');
    const decrease = stepper?.querySelector('[data-cart-quantity-decrease]');
    const increase = stepper?.querySelector('[data-cart-quantity-increase]');

    if (decrease) {
      decrease.addEventListener('click', async () => {
        const value = clampCartInput(input);
        if (value > 0) await changeCartLine(input, value - 1);
      });
    }

    if (increase) {
      increase.addEventListener('click', async () => {
        const value = clampCartInput(input);
        const max = Number.parseInt(input.max || '', 10);
        if (!Number.isFinite(max) || value < max) await changeCartLine(input, value + 1);
      });
    }

    clampCartInput(input);
  });

  if (cartForm) {
    cartForm.addEventListener('submit', () => {
      cartQtyInputs.forEach(input => clampCartInput(input));
    });

    const checkoutButton = cartForm.querySelector('[data-cart-checkout]');

    if (checkoutButton) {
      checkoutButton.addEventListener('click', async () => {
        checkoutButton.disabled = true;
        checkoutButton.textContent = 'Opening Checkout…';

        try {
          const currentInputs = Array.from(document.querySelectorAll('.cart-stock-quantity'));
          currentInputs.forEach(input => clampCartInput(input));

          const updates = {};
          currentInputs.forEach(input => {
            const key = input.dataset.cartKey;
            const qty = Number.parseInt(input.value || '0', 10);
            if (key) updates[key] = Number.isFinite(qty) ? qty : 0;
          });

          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ updates })
          });

          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.description || 'Could not update cart.');
          }

          window.location.assign('/checkout');
        } catch (error) {
          checkoutButton.disabled = false;
          checkoutButton.textContent = 'Checkout';

          let message = document.querySelector('[data-checkout-error]');
          if (!message) {
            message = document.createElement('div');
            message.setAttribute('data-checkout-error', '');
            message.className = 'checkout-error';
            checkoutButton.closest('.cart-actions')?.after(message);
          }
          message.textContent = error.message || 'Checkout could not be opened. Please try again.';
        }
      });
    }
  }

})();
